'use client';

import { createContext } from 'react';

import type { MindDetail } from '@/types/mindDetail';

export const ContextGeniusDetail = createContext<MindDetail>({});

interface IProps {
  detailInfo: MindDetail;
  children: React.ReactNode;
}

function ProviderGeniusDetail(props: IProps): JSX.Element {
  const { detailInfo, children } = props;

  return <ContextGeniusDetail.Provider value={detailInfo}>{children}</ContextGeniusDetail.Provider>;
}

export default ProviderGeniusDetail;
